import { Form, Input } from 'antd';
import { InverterApi } from 'api/InverterApi';
import { useAppSelector } from 'app/hooks';
import * as React from 'react';
import { selectInverterItemSidebar } from '../Sidebar/sidebarSlice';

export interface InputFieldProps {
  item: any;
}

export default function InputField(props: InputFieldProps) {
  const { item } = props;
  const [isValue, setIsValue] = React.useState<string | null>(null);
  const inverterId = useAppSelector(selectInverterItemSidebar);
  React.useEffect(() => {
    if (item) {
      (async () => {
        const response: any = await InverterApi.fetchStatisticByDevice({
          id: inverterId,
          text: item.key,
        });
        setIsValue(response[item.key][0].value);
      })();
    }
  }, [item, inverterId]);

  const renderInPut = (item: any, value: string) => (
    <Form.Item
      name={item.key}
      label={item.label}
      initialValue={value}
      style={{
        width: '50%',
      }}
      rules={
        item.input_type === 'NUMBER'
          ? [
              {
                validator: (_, value) => {
                  const integer_reg = /^[1-9][0-9]*$/;
                  if (integer_reg.test(value)) {
                    if (eval(item.condition.replace(/value/g, value))) {
                      return Promise.resolve();
                    } else {
                      return Promise.reject(
                        new Error(`input number out of range ${item.condition_label}`)
                      );
                    }
                  } else {
                    return Promise.reject(new Error(`input number integer`));
                  }
                },
              },
            ]
          : []
      }
    >
      <Input placeholder="placeholder" />
    </Form.Item>
  );
  return <>{isValue !== null && renderInPut(item, isValue)}</>;
}
